import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaReservation } from '@/service/tuina'

export const fetchTuinaReservation = createAsyncThunk(
  'tuinaReservationDetail/fetchTuinaReservation',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaReservation(query.id)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载预约详情失败'
      )
    }
  }
)

const reservationDetailSlice = createSlice({
  name: 'tuinaReservationDetail',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaReservation.pending, (state) => {
        state.fetching = true
        state.error = null
        state.data = {}
      })
      .addCase(fetchTuinaReservation.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || {}
      })
      .addCase(fetchTuinaReservation.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default reservationDetailSlice.reducer
